// extracted by mini-css-extract-plugin
export default {"flagImage":"customFlagCFD_flagImage__wIIs3"};